var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppCard',{attrs:{"color":true,"animate":'fade-right',"introImg":_vm.introImg,"title":'移动签到 - 微信小程序版',"introInfo":'适用于小规模会议或分会场的场景。支持：扫码、姓名、手机四位、邮箱等验证方式。微信扫描下方二维码，即刻使用。'},scopedSlots:_vm._u([{key:"download",fn:function(){return [_c('div',{staticClass:"weapp_code",style:({backgroundImage: 'url('+_vm.codeImg+')'})})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }